import React from 'react';

const HeroTransition = () => {
  return (
    <section className="py-16 md:py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-3xl md:text-5xl lg:text-6xl font-serif font-bold text-blue-900 mb-6 leading-tight">
            Hotel Montecarlo: Un destino pensado para toda la familia
          </h2>
          <p className="text-lg md:text-xl text-gray-700 leading-relaxed max-w-3xl mx-auto">
            Disfruta de momentos inolvidables en el corazón de Caldera - Bahía Inglesa, 
            donde cada espacio está diseñado para el confort de toda tu familia.
          </p>
        </div>
      </div>
    </section>
  );
};

export default HeroTransition;
